export const dateToAwsDateItalian = (date) => {
    console.log('date is ', date)
    const nd = new Date(date);
    console.log('nd is', nd)
    const month = nd.getMonth() < 9 ? '0' + (nd.getMonth() + 1) : (nd.getMonth() + 1);
    const day = nd.getDate() < 9 ? '0' + nd.getDate() : nd.getDate();
    const result = `${day}-${month}-${nd.getFullYear()}`
    console.log('result is', result)
    return result;
}